import React from 'react'
import SVG from "react-inlinesvg";
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import Mark from './Marks'
import eyeOpened from '@icons/eye/opened-white'
import { Can } from '@app/context/ability-context'
import classnames from 'classnames'

const Task = ({ item, index }) => {
  const {task, answer} = item
  return (
    <div className="task__wrapper">
      <div className="task">
        <div className="task__desc">
          <div className="task__num">{index + 1}</div>
          <Can I="read correctAnswer" of="Score" passThrough>
            {
              can => can ? (
                <Link
                  to={`/students/results/tasks/${task.id}`}
                  className="task__name"
                  title={I18n.t('cards.show_answer')}>
                  {task.name}
                </Link>
              ) : (
                <div className="task__name">{task.name}</div>
              )
            }
          </Can>
          <Mark tour="main" answer={answer}/>
        </div>
      </div>
      <Can I="read correctAnswer" of="Score" passThrough>
        {
          can => can ? (
            <div className="task__eye-outer">
              <Link
                to={`/students/results/tasks/${task.id}`}
              >
                <div className="task__eye-inner">
                  <SVG src={eyeOpened}/>
                </div>
              </Link>
            </div>
          ) : null
        }
      </Can>
    </div>
  )
}

const Column = ({items, length, column_index}) => {
  return (
    <div className="tasks-list__col">
      {
        _.map(items, (item, index) => {
          return (
            <Task key={item.task.id}
                  index={column_index * length + index}
                  item={item}
            />
          )
        })
      }
    </div>
  )
}

const Results = (props) => {
  const {statistics, className} = props
  const objects = _.values(statistics.objects)
  const length = Math.round(objects.length / 2)
  const chunks = _.chunk(objects, length)

  let modifier = {};
  if (className) { modifier[`tasks-list--${className}`] = true }

  const classes = classnames(
    'tasks-list', 'tasks-list--columns', modifier
  )

  return (
    <div className={classes}>
      {
        _.map(chunks, (items, index) => {
          return (
            <Column key={`column_${index}`} items={items} length={length} column_index={index} />
          )
        })
      }
    </div>
  )
}

Results.propTypes = {
  statistics: PropTypes.object.isRequired
}

export default Results
